/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Geetha",
  title: "Hi all, I'm Geetha",
  // subTitle: emoji(
  //   "Full-Stack Software Engineer with 5+ years of experience building scalable, high-performance web and mobile applications across startups and research labs. Proficient in JavaScript, Vue.js, React, Node.js, FastAPI, Firebase, SQL, and cloud platforms like AWS and GCP. Skilled in real-time systems, RESTful APIs, CI/CD pipelines, and cross-platform development using React Native and Flutter. Passionate about solving meaningful problems with clean architecture, data-driven decisions, and intuitive UI/UX."
  // ),
  subTitle: emoji(
    "Full-Stack Software Engineer with 7+ years of experience building scalable, high-performance web and mobile applications. Proficient in JavaScript, Vue.js, React, Node.js, Firebase, SQL, and AWS. Passionate about clean architecture, real-time systems, and intuitive user experiences."
  ),
  // resumeLink:
  // "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ngkchaitanya",
  linkedin: "https://www.linkedin.com/in/chaitanya-nama/",
  gmail: "geethakcnama@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "CURIOUS FULL STACK DEVELOPER WHO LOVES BUILDING IMPACTFUL PRODUCTS",
  skills: [
    emoji(
      "⚡ Design and develop responsive, accessible UIs using React, Vue, and Tailwind CSS"
    ),
    emoji(
      "⚡ Architect full-stack applications using Node.js, FastAPI, Firebase, and SQL/NoSQL databases"
    ),
    emoji("⚡ Build cross-platform mobile apps using React Native and Flutter"),
    emoji(
      "⚡ Integrate third-party services like Firebase, AWS (EC2, S3, Lambda), and GCP"
    ),
    emoji(
      "⚡ Develop real-time features using WebSockets, Firestore, and Agora WebRTC"
    ),
    emoji(
      "⚡ Set up CI/CD pipelines, cloud deployments, and performance monitoring (Sentry, Redis, Docker)"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      // fontAwesomeClassname: "fab fa-html5"
      fontAwesomeClassname: "devicon-html5-plain"
    },
    {
      skillName: "css3",
      // fontAwesomeClassname: "fab fa-css3-alt"
      fontAwesomeClassname: "devicon-css3-plain"
    },
    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      // fontAwesomeClassname: "fab fa-js"
      fontAwesomeClassname: "devicon-javascript-plain"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "devicon-typescript-plain"
    },
    {
      skillName: "reactjs",
      // fontAwesomeClassname: "fab fa-react"
      fontAwesomeClassname: "devicon-react-original"
    },
    {
      skillName: "vuejs",
      // fontAwesomeClassname: "fab fa-vuejs"
      fontAwesomeClassname: "devicon-vuejs-plain"
    },
    {
      skillName: "nodejs",
      // fontAwesomeClassname: "fab fa-node"
      fontAwesomeClassname: "devicon-nodejs-plain"
    },
    {
      skillName: "expressjs",
      fontAwesomeClassname: "devicon-express-original"
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "devicon-nextjs-original-wordmark"
    },
    {
      skillName: "fastAPI",
      fontAwesomeClassname: "devicon-fastapi-plain"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      // fontAwesomeClassname: "fab fa-npm"
      fontAwesomeClassname: "devicon-npm-original-wordmark"
    },
    {
      skillName: "sql-database",
      // fontAwesomeClassname: "fas fa-database"
      fontAwesomeClassname: "devicon-sqldeveloper-plain"
    },
    {
      skillName: "aws",
      // fontAwesomeClassname: "fab fa-aws"
      fontAwesomeClassname: "devicon-amazonwebservices-plain-wordmark"
    },
    {
      skillName: "firebase",
      // fontAwesomeClassname: "fas fa-fire"
      fontAwesomeClassname: "devicon-firebase-plain"
    },
    {
      skillName: "mongoDB",
      fontAwesomeClassname: "devicon-mongodb-plain"
    },
    {
      skillName: "python",
      // fontAwesomeClassname: "fab fa-python"
      fontAwesomeClassname: "devicon-python-plain"
    },
    {
      skillName: "docker",
      // fontAwesomeClassname: "fab fa-docker"
      fontAwesomeClassname: "devicon-docker-plain"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "devicon-git-plain"
    },
    {
      skillName: "figma",
      // fontAwesomeClassname: "fab fa-figma"
      fontAwesomeClassname: "devicon-figma-plain"
    },
    {
      skillName: "Redux",
      fontAwesomeClassname: "devicon-redux-original"
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "devicon-tailwindcss-original"
    },
    {
      skillName: "REST API",
      fontAwesomeClassname: "fas fa-network-wired"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of South Florida",
      logo: require("./assets/images/usfLogo.jpg"),
      subHeader: "Master of Science in Computer Science",
      duration: "August 2023 - May 2025",
      desc: "GPA - 4.0/4.0"
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Vellore Institute of Technology",
      logo: require("./assets/images/vitUniversityLogo.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "June 2013 - May 2017",
      desc: "GPA - 8.05/10.0"
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "ImapBook",
      companylogo: require("./assets/images/imapbookLogo.png"),
      date: "August 2024 – Present",
      desc: "Text-based multiplayer game platform with real-time interaction and dynamic storytelling.",
      descBullets: [
        "Redesigned the Saboteur game UI/UX with intuitive phase transitions in Figma and a modular Vue.js interface using Pinia and CSS modules, driving a 25% increase in active users and improving game retention.",
        "Architected a full-stack system with isolated prod/dev environments on AWS (EC2, S3, CloudFront), integrating SQL Server and Firestore to balance structured and real-time data, ensuring uninterrupted gameplay during high user concurrency.",
        "Optimized FastAPI backend, cutting latency by 30% and improving fault tolerance for high concurrency voting and chat."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Dotosports",
      companylogo: require("./assets/images/dotoLogo.png"),
      date: "November 2020 – August 2022",
      desc: "Live sports quizzing and prediction app with real-time multiplayer gameplay.",
      descBullets: [
        "Spearheaded the development and architecture of Playdoto web and mobile apps using React.js, React Native, Node.js, and Express.js, ensuring seamless cross-platform user experiences for 12,000+ concurrent users.",
        "Led the development of a scalable real-time chat and quiz system using Firebase and Redux, maintaining sub-100ms latency to ensure smooth gameplay in high-traffic gaming sessions.",
        "Drove strategic planning and prototyping to deliver the MVP for ZuperCare, a health-tech web app built with Bubble.io, reducing time-to-market by 50% through agile iteration and continuous user feedback.",
        "Mentored a team of 4 developers while enforcing Agile practices and CI/CD, leading code reviews and process optimization that reduced technical debt by 15%.",
        "Learned React.js from scratch and developed InstaParty, a video calling app for social events using React.js and Agora.io, implementing real-time WebRTC-based communication and delivering the project within 6 weeks."
      ]
    },
    {
      role: "Software Development Engineer 2",
      company: "Evibe.in",
      companylogo: require("./assets/images/evibeLogo.png"),
      date: "August 2018 – October 2020",
      desc: "Online platform for booking personalized party services and managing partner operations.",
      descBullets: [
        "Improved system performance through caching (Redis, CDN), load balancing, and lazy loading, cutting page load times by 30% and increasing session duration by 20%, which helped retain users and support business growth.",
        "Ran A/B tests with Google Analytics to refine UI/UX, boosting user retention by 20% and enabling informed design.",
        "Spearheaded cross-functional efforts across engineering, business, and marketing to build a CMS-powered partner portal with integrated CRM tools, improving partner deliverables by 200% and streamlining external operations.",
        "Optimized SQL queries, lowering API response time by 40% and supporting scalability under high user load.",
        "Upgraded 4 legacy projects from Laravel 5.1 to 5.5 and migrated APIs, enhancing scalability and maintainability."
      ]
    },
    {
      role: "Software Development Engineer",
      company: "Evibe.in",
      companylogo: require("./assets/images/evibeLogo.png"),
      date: "June 2017 – July 2018",
      desc: "Event services marketplace offering real-time recommendations and internal sales tools.",
      descBullets: [
        "Engineered a full-stack sales dashboard with a responsive frontend and robust backend, integrating custom UI components, role-based access control, and real-time metrics to enhance team efficiency, driving a 20% increase in sales.",
        "Streamlined real-time recommendations, cutting manual work by 30% and enabling teams to focus on priority tasks.",
        "Implemented 30+ RESTful APIs with CRUD, enabling real-time updates and cross-platform compatibility for seamless UX."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/pharmCalculatorLogo.png"),
      projectName: "Pharm Calculator",
      projectDesc:
        "Developed a pharmacy formulation calculator using Next.js and TypeScript, featuring 6 models to validate drug compositions across 120+ compounds. Collaborated with chemists to ensure industry compliance and precision in pharmaceutical formulations.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://pharm-calculator.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/stridorDetectionLogo.jpg"),
      projectName: "Stridor Detection",
      projectDesc:
        "Built a deep learning pipeline using PyTorch, CNNs, and Vision Transformers (ViT) to detect stridor from speech recordings. Achieved 78% accuracy through feature engineering and data augmentation in collaboration with clinical researchers.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.b2aivoicescholars.org/#!biz/id/66ce90bda73fd95d12037334/About"
        }
      ]
    },
    {
      image: require("./assets/images/fallGuardLogo.png"),
      projectName: "FallGuard",
      projectDesc:
        "Created a cross-platform fall detection app using React Native and Firebase, integrating real-time alerts with geolocation via Google Maps API. Improved detection accuracy by 40% through motion sensor data analysis from accelerometer and gyroscope inputs.",
      footerLink: [
        {
          name: "View Demo",
          url: "https://www.youtube.com/watch?v=dRh7w2Jzmbg"
        }
      ]
    },
    {
      image: require("./assets/images/phZenLogo.png"),
      projectName: "PH Zen",
      projectDesc:
        "Designed and deployed a distraction-free Chrome extension for Product Hunt using JavaScript, TypeScript, and Manifest V3 APIs. Implemented dynamic DOM filtering, Chrome Storage API for preferences, and lightweight service workers for optimized performance.",
      footerLink: [
        {
          name: "Visit Tool",
          url: "https://chromewebstore.google.com/detail/ph-zen-distraction-free-p/jbfjjnfpjlidaemobgdjielabbkehdmk?pli=1"
        }
      ]
    },
    {
      image: require("./assets/images/quizBotLogo.png"),
      projectName: "Quizbot",
      projectDesc: "Built a single-player quiz widget using Preact, designed for seamless integration into third-party websites. Appears as a floating icon that expands into an interactive quiz experience, offering time-based challenges with post-quiz coupon/voucher rewards to boost user engagement.",
      footerLink: [
        {
          name: "View Screenshots",
          url: "https://drive.google.com/drive/folders/1XgsKqLFDfowF2dV4oMKLcboYp2GvDMKU"
        }
      ]
    },
    {
      image: require("./assets/images/instapartyLogo.png"),
      projectName: "Instaparty",
      projectDesc:
        "Built a single-player quiz widget using Preact, designed for seamless integration into third-party websites. Appears as a floating icon that expands into an interactive quiz experience, offering time-based challenges with post-quiz coupon/voucher rewards to boost user engagement.",
      footerLink: [
        {
          name: "View Screenshots",
          url: "https://drive.google.com/drive/folders/1rltGEtJAOyJ8RdC-ECh6ywEQv8VswKYM"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Poster Presentation",
      subtitle:
        "Presented our research on voice-based Stridor detection at the prestigious Combined Otolaryngology Spring Meetings (COSM) 2025, showcasing interdisciplinary collaboration in AI and healthcare.",
      image: require("./assets/images/cosmLogo.png"),
      imageAlt: "Google IO Extended",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Winner - Google IO Extended",
      subtitle: "Won 1st place at Google I/O Extended 2019 hackathon for building an innovative tech solution under tight time constraints and intense competition.",
      image: require("./assets/images/googleIOExtendedLogo.webp"),
      imageAlt: "Google IO Extended",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Paper Publication",
      subtitle:
        "Published a research paper titled 'The Effects of Schedule-Driven Project Management in Multi-Project Environments' in the IJPSAT, exploring the impact of scheduling constraints on parallel project execution during my undergraduate program.",
      image: require("./assets/images/ijpsatLogo.png"),
      imageAlt: "IJPSAT Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },
    {
      title: "Complete React",
      subtitle: "Completed a comprehensive React.js course on Udemy, strengthening my understanding of component-based architecture, hooks, and real-world application development.",
      image: require("./assets/images/udemyReactLogo.jpg"),
      imageAlt: "Udemy React Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },
    {
      title: "Product Management",
      subtitle:
        "Finished a practical Product Management course on Udemy, learning product lifecycle strategy, user-centric design, and agile delivery processes from concept to market.",
      image: require("./assets/images/udemyPMLogo.jpg"),
      imageAlt: "Udemy PM Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    }
    // {
    //   title: "Google Assistant Action",
    //   subtitle:
    //     "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
    //   image: require("./assets/images/googleAssistantLogo.webp"),
    //   imageAlt: "Google Assistant Action Logo",
    //   footerLink: [
    //     {
    //       name: "View Google Assistant Action",
    //       url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
    //     }
    //   ]
    // },

    // {
    //   title: "PWA Web App Developer",
    //   subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
    //   image: require("./assets/images/pwaLogo.webp"),
    //   imageAlt: "PWA Logo",
    //   footerLink: [
    //     {name: "Certification", url: ""},
    //     {
    //       name: "Final Project",
    //       url: "https://pakistan-olx-1.firebaseapp.com/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Have an idea, collaboration, or just want to chat about tech? Feel free to reach out. I’d love to hear from you.",
  // number: "+92-0000000000",
  email_address: "geethakcnama@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
